import { render, staticRenderFns } from "./MessageVideo.vue?vue&type=template&id=533e089e&scoped=true&"
import script from "./MessageVideo.vue?vue&type=script&lang=ts&"
export * from "./MessageVideo.vue?vue&type=script&lang=ts&"
import style0 from "./MessageVideo.vue?vue&type=style&index=0&id=533e089e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e089e",
  null
  
)

export default component.exports